import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="mx-auto w-full max-w-7xl">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs md:text-sm font-medium text-primary-800">
            <i className="ri-grid-line"></i>
            {t("nav.categories")}
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
            {t("button.exploreCategories")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("hero.secondary")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {categories.map((c) => (
            <a
              key={c.key}
              href={c.link}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-xl border border-background-200 bg-background-50 overflow-hidden cursor-pointer hover:border-primary-300 transition-colors"
            >
              <div className="w-full h-40 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={c.image}
                  alt={t(`cat.${c.key}`)}
                  title={`${t(`cat.${c.key}`)} — Basetao Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between gap-2 px-3.5 py-3">
                <span className="text-sm md:text-base font-medium text-foreground-900 whitespace-nowrap">
                  {t(`cat.${c.key}`)}
                </span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}